var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("page-layout", [
    _c(
      "div",
      { staticClass: "setting-wrapper" },
      [
        _c("sec-title", {
          staticClass: "setting-sec-title",
          attrs: { isShowHelp: false }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "content-wrapper" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              !!_vm.currHDAcc
                ? _c("div", { staticClass: "big-title" }, [
                    _vm._v(_vm._s(_vm.$t("setting.addrList")))
                  ])
                : _vm._e(),
              _vm._v(" "),
              !!_vm.currHDAcc ? _c("accList") : _vm._e(),
              _vm._v(" "),
              !!_vm.isLogin && !_vm.currHDAcc.isSeparateKey
                ? _c("div", { staticClass: "big-title" }, [
                    _vm._v(_vm._s(_vm.$t("setting.secure")))
                  ])
                : _vm._e(),
              _vm._v(" "),
              !!_vm.isLogin && !_vm.currHDAcc.isSeparateKey
                ? _c("mnemonic")
                : _vm._e(),
              _vm._v(" "),
              !!_vm.isLogin && !_vm.currHDAcc.isSeparateKey
                ? _c("hold-pwd", { staticClass: "item" })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "area" },
            [
              _c("div", { staticClass: "big-title" }, [
                _vm._v(_vm._s(_vm.$t("setting.config")))
              ]),
              _vm._v(" "),
              !!_vm.isLogin && !_vm.currHDAcc.isSeparateKey
                ? _c("auto-logout")
                : _vm._e(),
              _vm._v(" "),
              _c("lang"),
              _vm._v(" "),
              _c("currency"),
              _vm._v(" "),
              _c("gate")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "area" },
            [
              _c("div", { staticClass: "big-title" }, [
                _vm._v(_vm._s(_vm.$t("setting.netInfo")))
              ]),
              _vm._v(" "),
              _c("net-info")
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }